<div class="title-components">
  <h1>{{Group.Nombre}}</h1>
</div>


<div class="Options-Menu">

  <!---================= CONTAINER SELECT TYPE =================--->

  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-users"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Opciones usuarios</h2>
      </div>

      <div class="Input-Option DisplayInputs">

        <div class="Container-Buttons">

          <button (click)="Toggle_Modal_Relation_User(true)" class="Btn-Option Add button-square">
            <span class="Tool-Tip">Agregar usuario al grupo</span>
            <i class="fa-solid fa-plus"></i>
          </button>

        </div>
      </div>

    </div>

  </div>



  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-shield"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Permisos de grupo</h2>
      </div>

      <div class="Input-Option DisplayInputs">

        <!---================= CONTAINER RELOAD PAGE =================--->
        <div class="Container-Buttons">

          <div class="Container-Buttons--Permission">

            <ng-container *ngFor="let Group_Perm of Group.Permission">

              <ng-container *ngFor="let Permission of Permisions">

                <div *ngIf="Group_Perm === Permission.Permission" class="Container-Buttons--Permission--Icon">
                  <span class="Container-Buttons--Permission--Icon--Tool-Tip">
                    {{Permission.Value}}
                  </span>
                  <i class="fa-solid {{Permission.Icon}}"></i>
                </div>
              </ng-container>

            </ng-container>

          </div>

        </div>

      </div>

    </div>

  </div>

  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-hashtag"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Usuarios en el grupo</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <div class="Container-Buttons">
          <div class=" Generate-Report-Level">
            {{All_User_Group.length}}
          </div>
        </div>
      </div>

    </div>

  </div>

  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-gear"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Actualizar información</h2>
      </div>

      <div class="Input-Option DisplayInputs">

        <!---================= CONTAINER RELOAD PAGE =================--->
        <div class="Container-Buttons">

          <button (click)="Reload_Page()" class="Btn-Option button-square">
            <span class="Tool-Tip">Recargar pagina</span>
            <i class="fa-solid fa-rotate-right"></i>
          </button>

        </div>

      </div>

    </div>

  </div>


</div>


<!--&================== CONTAINER GENERAL LIBRARY ==================&-->
<div *ngIf="All_User_Group.length>0 && LoadPage" class="container-global-components ConFLFIN">

  <div class="Table-Lib Table-container-Global">

    <p-table #dt [value]="All_User_Group" [(selection)]="Selected_All_User_Group" dataKey="id" [rowHover]="true"
      [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25, 50]" [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [filterDelay]="0"
      [globalFilterFields]="['Nombre','Descripcion']">


      <!--&================= SEARCH AND ALL Groups =================&-->
      <ng-template pTemplate="caption">
        <div class="SectionCreateTotal Section-Groups Table_NG">
          <div class="left-CT">
            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="Input_Search" type="text"
                (input)="dt.filterGlobal(Input_Search, 'contains')" placeholder="Buscar usuario" />
            </div>
          </div>
          <div class="right-CT">
            <div class="AllFiles">Usuarios que pertenecen al grupo: <b>{{All_User_Group.length}}</b> <i
                class="fa-solid fa-users"></i>
            </div>
          </div>
        </div>
      </ng-template>


      <ng-template pTemplate="header">

        <tr>
          <ng-container *ngFor="let Header of Headers_Group">

            <ng-container *ngIf="Header.Key_Header==='NAME'">
              <th pSortableColumn="Nombre" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Nombre"></p-sortIcon>
                    <p-columnFilter type="text" field="Nombre" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='EMAI'">
              <th pSortableColumn="Descripcion" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Descripcion"></p-sortIcon>
                    <p-columnFilter type="text" field="Descripcion" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='LONA'">
              <th class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='OPTI'">
              <th>
                <!-- <i class="fa-regular fa-trash-can"></i> -->
              </th>
            </ng-container>

          </ng-container>
        </tr>

      </ng-template>


      <ng-template pTemplate="body" let-All_User_Group>

        <tr>
          <td *ngFor="let Header of Headers_Group" class="{{Header.Key_Header}}">

            <ng-container *ngIf="Header.Key_Header==='NAME'">
              {{All_User_Group.Nombre}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='EMAI'">
              {{All_User_Group.email}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='LONA'">
              {{Format_LoginName(All_User_Group.LoginName)}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='OPTI'">
              <button (click)="Delete_User_To_Group(All_User_Group)" class="Btn-Option button-square Remove">
                <i class="fa-regular fa-trash-can"></i>
              </button>
            </ng-container>

          </td>

        </tr>

      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td *ngIf="All_User_Group.length>0" colspan="8">Sin coincidencias.</td>
        </tr>
      </ng-template>

    </p-table>

  </div>

</div>

<div *ngIf="All_User_Group.length===0 && LoadPage" class="container-global-components ConFLFIN">
  <div class="Not-User">
    <div class="Img-Not">
      <img src="./assets/Global/Ilustrations/Not-User.png" alt="">
    </div>
    <div class="Text-Not-User">
      ¡Aún no existen usuarios relacionados con el grupo {{Group.Nombre}}!
    </div>
  </div>
</div>


<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR RELATION USER =====================--->
<section class="Modal-Global" id="Modal_Relation_User">
  <div class="wrapper">
    <div class="Pro-popup-RU popup">
      <div class="Pro-inside-RU popup-inside">
        <div class="Pro-backgrounds-RU backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form>
        <div class="Pro-content-RU content">
          <button (click)="Toggle_Modal_Relation_User(false)" type="button" id="Btn-Close-Add-Top" class="Btn-Close"><i
              class="fa-solid fa-xmark"></i></button>
          <div class="Content-Top">
            <h2>Agregar usuario al grupo</h2>
          </div>

          <div class="Content-body">

            <div class="SectionCreateTotal Section-Task">
              <div class="left-CT">
                <div class="Search inputText">
                  <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="Input_Search_User" name="something"
                    type="text" (keyup)="Search_User()" (keyup)="Search_Enter($event)" placeholder="Buscar usuario (Mínimo 2 caracteres)" />
                </div>
              </div>
              <div class="right-CT">
                <div class="AllFiles">Total de usuarios sin relación: <b>{{All_User_CDMS.length}}</b> <i
                    class="fa-solid fa-users"></i>
                </div>
              </div>
            </div>

            <div class="Card">
              <div class="Card__Container">

                <div *ngFor="let User of All_User_CDMS_Copy;let i = index" class="Card__Container--Item">

                  <div class="Card__Container--Item--Check {{ContainMail(User.email)}}">
                    <i class="fa-solid fa-check"></i>
                  </div>

                  <div class="Card__Container--Item--Body">
                    <div class="Card__Container--Item--Body--Img">
                      <span class="Card__Container--Item--Body--Img--Name">{{Format_Initials(User.Nombre)}}</span>
                      <span class="Card__Container--Item--Body--Img--Point"></span>
                    </div>
                    <div class="Card__Container--Item--Body--Name">
                      {{User.Nombre}}
                    </div>
                    <div class="Card__Container--Item--Body--Description">
                      {{Format_LoginName(User.LoginName)}}
                    </div>

                    <div class="Card__Container--Item--Body--Info">
                      <div class="Card__Container--Item--Body--Info--Section">
                        <div class="Card__Container--Item--Body--Info--Section--Icon">
                          <i class="fa-regular fa-envelope"></i>
                        </div>
                        <div class="Card__Container--Item--Body--Info--Section--InfoS">
                          <div class="Card__Container--Item--Body--Info--Section--InfoS--Title">
                            Correo electronico
                          </div>
                          <div class="Card__Container--Item--Body--Info--Section--InfoS--Description">
                            {{Format_Mail(User.email)}}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="Card__Container--Item--Body--Info">
                      <div class="Card__Container--Item--Body--Info--Section--Container-Button">
                        <button type="button" (click)="Add_User_To_Group(User)"
                          class="Card__Container--Item--Body--Info--Section--Container-Button--Button btn-icon-text">
                          <i class="fa-solid fa-plus"></i><span class="text">Agregar usuario</span>
                        </button>
                      </div>
                    </div>

                  </div>

                </div>


              </div>
            </div>
            <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
              [totalRecords]="Input_Search_User.length < 2 ? All_User_CDMS.length:All_User_CDMS_Copy_Search.length"
              [rowsPerPageOptions]="[5, 10, 15, 20, 30]"></p-paginator>
          </div>

        </div>

      </form>

    </div>
  </div>
</section>


<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
